import React, { useState } from 'react';
import styled from 'styled-components';
import { ModalFooter } from 'styled_components/Common/ModalFooter';
import { PortraitModalComponent } from 'styled_components/Common/PortraitModalComponent';
import { BloxButton } from 'styled_components/Common/BloxButton';
import { Divider } from 'styled_components/Common/Divider';
import Modal from 'sub_components/Common/PortalModalNew';
import { PopUp } from 'styled_components/Common/PopUp';

const ModalsStyle = styled.div`
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;
const popUpContent =
	"<div className='soft-error'><div className='top-message'>Error message of your choice.</div><div className='bottom-message'>If the problem persists please call<br />877-590-1684.</div></div>";

export const Modals = () => {
	const [popUp, setPopUp] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [modalType, setModalType] = useState('small');
	return (
		<ModalsStyle>
			<div className='component'>
				<Divider />
				<div className='component-title heading70'>Portrait Modal</div>
				<div className='component-body'>
					<BloxButton
						text='Small'
						module='support'
						enabled={true}
						id='modal-small'
						className='buttons41'
						onClick={() => {
							setModalType('small');
							setShowModal(!showModal);
						}}
					/>
					<BloxButton
						text='Medium'
						module='support'
						enabled={true}
						id='modal-medium'
						className='buttons41'
						onClick={() => {
							setModalType('medium');
							setShowModal(!showModal);
						}}
					/>
					<BloxButton
						text='Large'
						module='support'
						enabled={true}
						id='modal-large'
						className='buttons41'
						onClick={() => {
							setModalType('large');
							setShowModal(!showModal);
						}}
					/>
					<PortraitModalComponent
						closeModal={() => setShowModal(!showModal)}
						show={showModal}
						//header={getHeader(activePageIndex)}
						title='MODAL TITLE'
						subTitle={'Modal subtitle'}
						size={modalType}
						breakpoint={breakpoint}
					>
						<ModalFooter
							cypressId='footer'
							id='footer'
							buttonText1={'Next'}
							buttonText2='Back'
							buttonActive1={true}
							buttonActive2={true}
							module='storage'
							buttonFunction1={() => {}}
							size={modalType}
							buttonFunction2={() => {}}
						/>
					</PortraitModalComponent>
				</div>
			</div>
			<div className='component'>
				<Divider />
				<div className='component-title heading70'>Pop Up Modal</div>
				<div className='component-body '>
					<BloxButton
						text='Show'
						module='support'
						enabled={true}
						id='pop-up'
						className='buttons41'
						onClick={() => {
							setPopUp(!popUp);
						}}
					/>
					{popUp && (
						<Modal>
							<PopUp
								showModal={popUp}
								closeModal={() => setPopUp(!popUp)}
								customBody={popUpContent}
								footer={
									<BloxButton
										className='buttons41'
										id='okay'
										text='CLOSE'
										module='support'
										enabled={true}
										onClick={() => setPopUp(!popUp)}
										cypressId='okay'
									/>
								}
								title={'Title Text'}
								text='More text'
								module='support'
							/>
						</Modal>
					)}
				</div>
			</div>
		</ModalsStyle>
	);
};
